import * as React from "react";
import { forwardRef } from "react";
const ReactComponent = ({ title, titleId, ...props }, ref) => React.createElement("svg", { "data-testid": "information-filled-outline-17", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 17", ref: ref, "aria-labelledby": titleId, ...props },
    title ? React.createElement("title", { id: titleId }, title) : null,
    React.createElement("g", { fill: "none", fillRule: "evenodd", transform: "translate(2 2)" },
        React.createElement("circle", { cx: 6.5, cy: 6.5, r: 7, fill: "currentColor", fillOpacity: 0.2, stroke: "currentColor" }),
        React.createElement("g", { transform: "translate(5.5 2.5)" },
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "M0 4h1v3" }),
            React.createElement("circle", { cx: 1, cy: 1, r: 1, fill: "currentColor" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", d: "M0 7h2" }))));
const ForwardRef = forwardRef(ReactComponent);
export { ForwardRef as ReactComponent };
